import { SxProps } from '@mui/material';

export const companyInput: SxProps = {
  backgroundColor: '#ffffff',
  mr: 5,
};

export const confirmButton: SxProps = {
  minWidth: '80px',
  backgroundColor: 'secondary.main',
  color: 'primary.contrastText',
  marginRight: 2,
  '&:hover': {
    backgroundColor: 'secondary.main',
  },
};

export const cancelButton: SxProps = {
  minWidth: '80px',
  color: 'primary.contrastText',
  border: 1,
  borderColor: 'primary.contrastText',
  '&:hover': {
    borderColor: 'primary.contrastText',
  },
};

export const input: SxProps = {
  '&.MuiTextField-root': {
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      '&.Mui-error fieldset': {
        borderWidth: '3px',
      },
    },
  },
};
